<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1427747" style="color: #82a339"><b>PROSCIUTTO-WRAPPED ASPARAGUS</b></p>
<p class="ext" id="d7e1428247"><b><i>Delicate, succulent asparagus is the perfect foil for salty prosciutto. You can assemble these early in the day and bake them at the very last minute.</i></b></p>
<p class="h4" id="d7e1429547" style="color: #496210"><b>Prep: 25 minutes       Bake: 10 minutes</b></p>
<p class="ul" id="d7e1430047">24 thick asparagus spears, trimmed and peeled</p>
<p class="ul" id="d7e1430347">12 thin slices prosciutto (5 ounces)</p>
<p class="ul" id="d7e1430647">½ cup freshly grated Parmesan cheese</p>
<p class="ul" id="d7e1431547">¼ teaspoon coarsely ground black pepper</p>
<p class="pub" id="d7e1432747" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 5-quart Dutch oven, heat <i>3 quarts water </i>to boiling over high heat. Add asparagus; cook 3 minutes to blanch. Drain; rinse with cold running water. Pat dry with paper towels.</p>
<p class="pub" id="d7e1434847"><span style="color: #c15b49"><b>2.</b></span> Preheat oven to 450°F. Working in batches, spread out prosciutto on cutting board; cut each slice lengthwise in half and separate slightly. Evenly sprinkle 1 teaspoon Parmesan on each prosciutto strip. Place 1 asparagus spear at end of 1 strip; wrap prosciutto in spiral along length of asparagus (don’t cover asparagus tip). Transfer to jelly-roll pan. Repeat with remaining prosciutto, Parmesan, and asparagus. Sprinkle with pepper. If not serving right away, cover and refrigerate up to 6 hours.</p>
<p class="pub" id="d7e1438447"><span style="color: #c15b49"><b>3.</b></span> Bake prosciutto-wrapped asparagus 10 minutes. Transfer to paper towels to drain. Arrange on platter and serve warm. Makes 24 appetizers.</p>
<p class="ntx" id="d7e1440247">Each appetizer: About 28 calories, 3g protein, 1g carbohydrate, 2g total fat (1g saturated), 6mg cholesterol, 148mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c40_r1.vue?663885b6